package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.repository.AppointmentRepository
import kotlinx.coroutines.flow.Flow

class GetAppointmentsInRangeUseCase(
    private val repository: AppointmentRepository
) {
    operator fun invoke(startDateIso: String, endDateIso: String): Flow<List<Appointment>> {
        return repository.getAppointmentsInRange(startDateIso, endDateIso)
    }
}
